import LocationOnIcon from "@mui/icons-material/LocationOn";

const EastIndia = () => {
  return (
    <div>
      <div className="offices_div1">
        <div className="offices_div11">
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Oplus+Cowork/@25.6107141,85.0578984,17z/data=!3m1!4b1!4m5!3m4!1s0x39ed5825b76c5de9:0x2948c2699eb29064!8m2!3d25.6107093!4d85.0600871?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Oplus+Cowork/@25.6107141,85.0578984,17z/data=!3m1!4b1!4m5!3m4!1s0x39ed5825b76c5de9:0x2948c2699eb29064!8m2!3d25.6107093!4d85.0600871?coh=164777&entry=tt&shorturl=1"
              >
                Patna, Bihar
              </a>
              <p>
                Oplus Cowork, C/O 3rd Floor, <br />
                RK Niwas, Near Ishan Int Girls School, <br />
                Bailey Road, Rupashpur, Patna,<br /> Bihar - 801 503
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a target="_blank" href=" ">
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a target="_blank" href="">
                Imphal, Manipur
              </a>
              <p>
                Village No 28, Porompat, Porompat, Thawanthaba <br /> Lelkal,
                P.O. and P.S. Porompat Imphal East,<br /> Manipur - 795 005
              </p>
            </div>
          </div>
        </div>
        <div className="offices_div11">
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Officetribe+Coworking+Space/@26.1524627,91.782597,17z/data=!3m1!4b1!4m6!3m5!1s0x375a591f9eb8d6f7:0xe28f72308505b7c1!8m2!3d26.1524627!4d91.782597!16s%2Fg%2F11j50dd1dd?entry=ttu"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Officetribe+Coworking+Space/@26.1524627,91.782597,17z/data=!3m1!4b1!4m6!3m5!1s0x375a591f9eb8d6f7:0xe28f72308505b7c1!8m2!3d26.1524627!4d91.782597!16s%2Fg%2F11j50dd1dd?entry=ttu"
              >
                Guwahati, Assam
              </a>
              <p>
                Office Tribe Coworking, C/o Guwahati Tea Warehousing <br /> Pvt.
                Ltd. House No. 183, Shreeji Tower, 1st Floor,
                <br /> Chirstian Basti, G.S Road, Guwahati,<br /> Assam - 781 005
              </p>
            </div>
          </div>
          <div className="offices_div111">
            <a
              target="_blank"
              href="https://www.google.com/maps/place/Awfis+Rajarhat+Ecospace+Business+Park+Premises/@22.5871114,88.4878046,17z/data=!3m1!4b1!4m5!3m4!1s0x3a02753758868fed:0x40067068542508e8!8m2!3d22.5871065!4d88.4899933?coh=164777&entry=tt&shorturl=1"
            >
              <LocationOnIcon sx={{ fontSize: 60, color: "#2D3985" }} />
            </a>
            <div className="offices_loca">
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Awfis+Rajarhat+Ecospace+Business+Park+Premises/@22.5871114,88.4878046,17z/data=!3m1!4b1!4m5!3m4!1s0x3a02753758868fed:0x40067068542508e8!8m2!3d22.5871065!4d88.4899933?coh=164777&entry=tt&shorturl=1"
              >
                Kolkata, West Bengal
              </a>
              <p>
                AWFIS, Rajarhat Phase II, 2A, 6th Floor, Ecospace <br />{" "}
                Business Park Premises, AA II, Kolkata, <br />West Bengal -  700
                156
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EastIndia;
